import { render, staticRenderFns } from "./FormDatePicker.vue?vue&type=template&id=b55b23f2&"
import script from "./FormDatePicker.vue?vue&type=script&lang=js&"
export * from "./FormDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./FormDatePicker.vue?vue&type=style&index=0&id=b55b23f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports